import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  IOdbBillProductSplit,
  IBillingDocument,
  IBillingAccount,
} from '@dch/billing-business-logic';
import { OVERVIEW_PAGE } from '../../config/my-bill.constants';
import { ISelectedThirdPartyProductSplitInfo } from '../../models/pii.model';
import {
  ODB_THIRD_PARTY_L3_PAGE_SESSION_DATA_KEY,
  UtilsService,
} from '../../services/utils.service';
import { BillingAnalyticsService } from '../../services/billing-analytics.service';

@Component({
  selector: 'my-bill-odb-third-party-level-three-page',
  templateUrl: './odb-third-party-level-three-page.component.html',
  standalone: false,
})
export class OdbThirdPartyLevelThreePageComponent implements OnInit {
  selectedThirdPartyProductSplitInfo?: ISelectedThirdPartyProductSplitInfo;
  openTransactionToPayIndex?: number;
  documentReference?: string;
  billingAccount?: IBillingAccount;
  billingDocument: IBillingDocument;
  hasDataAvailable: boolean;
  productSplit: IOdbBillProductSplit | undefined;
  customerId?: number;
  customerSubsegment?: string;
  customerGlobalId?: string;
  customerMobile?: string;

  constructor(
    private router: Router,
    private utilsService: UtilsService,
    private billingAnalyticsService: BillingAnalyticsService
  ) {}

  ngOnInit() {
    this.selectedThirdPartyProductSplitInfo =
      this.utilsService.getInfoFromSessionStorage<ISelectedThirdPartyProductSplitInfo>(
        ODB_THIRD_PARTY_L3_PAGE_SESSION_DATA_KEY
      );
    this.billingAccount =
      this.selectedThirdPartyProductSplitInfo?.billingAccount;
    this.documentReference =
      this.selectedThirdPartyProductSplitInfo?.billDocument.reference;
    this.productSplit =
      this.selectedThirdPartyProductSplitInfo?.selectedProductSplit;

    this.hasDataAvailable =
      this.selectedThirdPartyProductSplitInfo !== undefined &&
      this.billingAccount !== undefined &&
      this.documentReference !== undefined &&
      this.productSplit?.identifier !== undefined;

    if (this.hasDataAvailable) {
      this.extractSelectedOdbDetailsInfo();
      this.getPageImpressionTagging();
    } else {
      this.router.navigate([OVERVIEW_PAGE]);
    }
  }

  private extractSelectedOdbDetailsInfo() {
    this.openTransactionToPayIndex =
      this.selectedThirdPartyProductSplitInfo.openTransactionToPayIndex;
    this.billingDocument = this.selectedThirdPartyProductSplitInfo.billDocument;
    this.customerId = this.selectedThirdPartyProductSplitInfo?.customerId;
    this.customerGlobalId =
      this.selectedThirdPartyProductSplitInfo?.customerGlobalId;
    this.customerSubsegment =
      this.selectedThirdPartyProductSplitInfo?.customerSubsegment;
    this.customerMobile =
      this.selectedThirdPartyProductSplitInfo?.customerMobile;
  }

  private getPageImpressionTagging() {
    this.billingAnalyticsService.reportPageImpressionEvent(
      'detail.thirdParty.details',
      this.documentReference,
      this.billingAccount.accountNumber,
      undefined,
      this.customerId,
      this.customerSubsegment,
      this.customerGlobalId,
      this.customerMobile
    );
  }
}
